import { render, staticRenderFns } from "./UpgradeDealToMenuDialog.vue?vue&type=template&id=67487390&scoped=true"
import script from "./UpgradeDealToMenuDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeDealToMenuDialog.vue?vue&type=script&lang=js"
import style0 from "./UpgradeDealToMenuDialog.vue?vue&type=style&index=0&id=67487390&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67487390",
  null
  
)

export default component.exports